import React from "react";
import CommunityBoard from "@/components/CommunityBoard";

export default function Meals() {
  return <CommunityBoard kind="meal" />;
}
